import { render, staticRenderFns } from "./AddPurchaseReturn.vue?vue&type=template&id=76e04f8a&"
import script from "./AddPurchaseReturn.vue?vue&type=script&lang=js&"
export * from "./AddPurchaseReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports